var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"destaque"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('PortalNoticiasCartao')],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[_c('PortalTarefasCartao')],1),_c('div',{staticClass:"col-xl-6"},[_c('PortalAvisosCartao')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }